module.exports = __webpack_public_path__ + "img/RCT06.3f862ae3.svg";